export default "__VITE_ASSET__CMG1A$ub__"